import React, { useState } from 'react'
import { useTranslation } from 'react-i18next';
import useDesktopSize from '../../../../../../utils/hooks/useDesktopSize';
import { Ticket } from '../../../../../models/Ticket';
import QrCodeModal from '../../../../../../features/QRcode';
import EAButton from '../../../../shared/Buttons/EAButton';
import { isTicketExpired, isTicketInactive, isTicketUsedUp } from '../../../../../utils/TicketPassHelper';

interface IProps {
  pass: Ticket;
}

const DetailsQR: React.FC<IProps> = ({ pass }) => {
    const isDesktop = useDesktopSize();
    const { t } = useTranslation();
    const [forceShow, setForceShow] = useState(false);

    // Wykorzystany/wygasły/bez przypisanego terminu bilet nadal może wymagać pokazania kodu
    // (np. weryfikacja przez obsługę) — zamiast całkiem ukrywać sekcję, przyciemniamy ją
    // i chowamy kod za przyciskiem. Bez terminu (SELECT/FLEXI) i tak nie da się wejść, więc
    // aktywnie zapraszający kod QR byłby mylący.
    const isDimmed = (isTicketExpired(pass) || isTicketUsedUp(pass) || isTicketInactive(pass)) && !forceShow;

    const getQrSectionText = () => {
        return isDesktop ? t("dostep_do_biletu_desktop") : t("pokaz_ten_kod_mobile");
      };

  return (
    <div className="ticket-details__qr-section">
      <h5>{t("zeskanuj_ten_qr")}</h5>

      {isDimmed ? (
        <div className="ticket-details__qr-container ticket-details__qr-container--dimmed">
          <span className="body-text-small text-color-light-gray">{t("qr_niedostepny_info")}</span>
          <EAButton title={t("pokaz_kod_qr")} variant="text" compact onClick={() => setForceShow(true)} />
        </div>
      ) : (
        <>
          <span className="body-text-small text-color-light-gray">{getQrSectionText()}</span>
          <div className="ticket-details__qr-container">
            <QrCodeModal name={pass.name} trhId={pass.trhId || ""} customDesktopSize={200} customMobileSize={180} />
          </div>
        </>
      )}
    </div>
  )
}

export default DetailsQR
